import { z } from 'zod';

import { CompanyStatusViewSchema } from '../admin/companies';
import { WorkerStatus } from '../admin/workers';
import { IsoDateTimeSchema } from '../common/datetime';
import { TimezoneSchema } from '../common/fields';
import { DeviceId, SiteId, WorkerId } from '../common/ids';

import { DevicePlatform, DisplayMode } from './devices';
import { PrivacyNoticeStateSchema } from './privacy';

// ---------------------------------------------------------------------------
// `GET /me` del realm staff (contracts/staff-api.md · StaffMe)
// ---------------------------------------------------------------------------

export const StaffMeWorkerSchema = z.object({
  id: WorkerId,
  first_names: z.string(),
  last_names: z.string(),
  status: WorkerStatus,
});
export type StaffMeWorker = z.infer<typeof StaffMeWorkerSchema>;

export const StaffMeDeviceSchema = z.object({
  id: DeviceId,
  platform: DevicePlatform,
  display_mode: DisplayMode,
  enrolled_at: IsoDateTimeSchema,
});
export type StaffMeDevice = z.infer<typeof StaffMeDeviceSchema>;

export const StaffMeSiteSchema = z.object({
  id: SiteId,
  name: z.string(),
  timezone: TimezoneSchema,
  is_primary: z.boolean(),
});
export type StaffMeSite = z.infer<typeof StaffMeSiteSchema>;

/**
 * `200 StaffMe`. Responde también con empresa `SUSPENDED` y con privacidad pendiente para que la
 * UI enrute a la pantalla correcta.
 */
export const StaffMeSchema = z.object({
  worker: StaffMeWorkerSchema,
  /** `{ id, trade_name, status, default_timezone }` (mismo DTO que `CompanyStatusViewSchema`). */
  company: CompanyStatusViewSchema,
  device: StaffMeDeviceSchema,
  sites: z.array(StaffMeSiteSchema),
  privacy_notice: PrivacyNoticeStateSchema,
});
export type StaffMe = z.infer<typeof StaffMeSchema>;
